import { Col, Row } from "@ir/ui";
import type { ReactNode } from "react";

export interface OrganizationDetailsTwoColumnLayoutProps {
  children: ReactNode;
}

export const OrganizationDetailsTwoColumnLayout = ({
  children,
}: OrganizationDetailsTwoColumnLayoutProps) => {
  const allChildren = Array.isArray(children) ? children : [children];
  const leftColumn = allChildren.filter((_, index) => index % 2 === 0);
  const rightColumn = allChildren.filter((_, index) => index % 2 === 1);

  return (
    <Row className="mt-3">
      <Col span={12} md={6}>
        {leftColumn}
      </Col>
      <Col span={12} md={6}>
        {rightColumn}
      </Col>
    </Row>
  );
};
